var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "nonzero",
    d: "M811.5 206c4.694 0 8.5 3.76 8.5 8.4 0 3.068-1.429 6.078-3.762 8.814-1.72 2.016-3.886 3.786-4.738 3.786-.852 0-3.019-1.77-4.738-3.786-2.333-2.736-3.762-5.746-3.762-8.814 0-4.64 3.806-8.4 8.5-8.4zm0 2.1c-3.52 0-6.375 2.82-6.375 6.3 0 2.493 1.223 5.069 3.262 7.46.77.903 1.611 1.722 2.395 2.362.315.257.718.546.718.546s.448-.325.718-.546c.784-.64 1.626-1.459 2.395-2.361 2.04-2.392 3.262-4.968 3.262-7.461 0-3.48-2.854-6.3-6.375-6.3zm0 3.15c1.76 0 3.188 1.41 3.188 3.15s-1.428 3.15-3.188 3.15c-1.76 0-3.188-1.41-3.188-3.15s1.428-3.15 3.188-3.15zm0 2.1c-.587 0-1.063.47-1.063 1.05 0 .58.476 1.05 1.063 1.05s1.063-.47 1.063-1.05c0-.58-.476-1.05-1.063-1.05z",
    transform: "translate(-803 -206)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLocation);
export default __webpack_public_path__ + "static/media/filter-location.162e746c05f9f142b30941354cb51a09.svg";
export { ForwardRef as ReactComponent };